import {
  caseSensitiveRegexOperators,
  inetOperators,
  intOperators,
  OperatorsDictionary,
  regexOperators,
  stringOperators
} from '@kentik/ui-shared/dictionary/operators';

export const operators: OperatorsDictionary = {
  src_cloud: {
    '=': 'equals',
    '<>': 'does not equal'
  },
  dst_cloud: {
    '=': 'equals',
    '<>': 'does not equal'
  },
  'src|dst_cloud': {
    '=': 'equals',
    '<>': 'does not equal'
  },
  src_cloud_service: { ...stringOperators, ...regexOperators },
  dst_cloud_service: { ...stringOperators, ...regexOperators },
  'src|dst_cloud_service': { ...stringOperators, ...regexOperators },
  i_input_vrf: stringOperators,
  i_output_vrf: stringOperators,
  'i_input|output_vrf': stringOperators,
  input_vrf: intOperators,
  output_vrf: intOperators,
  'input|output_vrf': intOperators,
  i_input_vrf_rd: stringOperators,
  i_output_vrf_rd: stringOperators,
  'i_input|output_vrf_rd': stringOperators,
  i_input_vrf_rt: stringOperators,
  i_output_vrf_rt: stringOperators,
  'i_input|output_vrf_rt': stringOperators,
  i_dst_rpki_name: stringOperators,
  i_dst_rpki_min_name: stringOperators,
  dscp: {
    '=': 'equals',
    '<>': 'does not equal'
  },
  ecn: {
    '=': 'equals',
    '<>': 'does not equal'
  },
  kflow_http_status: intOperators,
  src_threat_bnetcc: stringOperators,
  dst_threat_bnetcc: stringOperators,
  'src|dst_threat_bnetcc': stringOperators,
  src_threat_host: stringOperators,
  dst_threat_host: stringOperators,
  'src|dst_threat_host': stringOperators,
  src_cdn: { ...stringOperators, ...regexOperators },
  dst_cdn: { ...stringOperators, ...regexOperators },
  'src|dst_cdn': { ...stringOperators, ...regexOperators },
  input_port: intOperators,
  output_port: intOperators,
  'input|output_port': intOperators,
  ult_exit_port: intOperators,
  vlan_in: intOperators,
  vlan_out: intOperators,
  'vlan_in|out': intOperators,
  l4_src_port: intOperators,
  l4_dst_port: intOperators,
  'l4_src|dst_port': intOperators,
  src_as: intOperators,
  dst_as: intOperators,
  'src|dst_as': intOperators,
  src_nexthop_as: intOperators,
  dst_nexthop_as: intOperators,
  'src|dst_nexthop_as': intOperators,
  src_second_asn: intOperators,
  dst_second_asn: intOperators,
  'src|dst_second_asn': intOperators,
  src_third_asn: intOperators,
  dst_third_asn: intOperators,
  'src|dst_third_asn': intOperators,
  src_secondhop_asn_noprepend: intOperators,
  dst_secondhop_asn_noprepend: intOperators,
  'src|dst_secondhop_asn_noprepend': intOperators,
  src_thirdhop_asn_noprepend: intOperators,
  dst_thirdhop_asn_noprepend: intOperators,
  'src|dst_thirdhop_asn_noprepend': intOperators,
  src_asn_generic: intOperators,
  dst_asn_generic: intOperators,
  'src|dst_asn_generic': intOperators,
  i_src_as_name: stringOperators,
  i_dst_as_name: stringOperators,
  'i_src|dst_as_name': stringOperators,
  i_src_nexthop_as_name: stringOperators,
  i_dst_nexthop_as_name: stringOperators,
  'i_src|dst_nexthop_as_name': stringOperators,
  i_src_second_asn_name: stringOperators,
  i_dst_second_asn_name: stringOperators,
  'i_src|dst_second_asn_name': stringOperators,
  i_src_third_asn_name: stringOperators,
  i_dst_third_asn_name: stringOperators,
  'i_src|dst_third_asn_name': stringOperators,
  i_src_secondhop_asn_noprepend_name: stringOperators,
  i_dst_secondhop_asn_noprepend_name: stringOperators,
  'i_src|dst_secondhop_asn_noprepend_name': stringOperators,
  i_src_thirdhop_asn_noprepend_name: stringOperators,
  i_dst_thirdhop_asn_noprepend_name: stringOperators,
  'i_src|dst_thirdhop_asn_noprepend_name': stringOperators,
  i_src_asn_generic_name: stringOperators,
  i_dst_asn_generic_name: stringOperators,
  'i_src|dst_asn_generic_name': stringOperators,
  src_flow_tags: {
    ILIKE: 'contains',
    'NOT ILIKE': 'does not contain'
  },
  dst_flow_tags: {
    ILIKE: 'contains',
    'NOT ILIKE': 'does not contain'
  },
  'src|dst_flow_tags': {
    ILIKE: 'contains',
    'NOT ILIKE': 'does not contain'
  },
  inet_src_addr: inetOperators,
  inet_dst_addr: inetOperators,
  'inet_src|dst_addr': inetOperators,
  inet_src_next_hop: inetOperators,
  inet_dst_next_hop: inetOperators,
  'inet_src|dst_next_hop': inetOperators,
  inet_src_route_prefix: inetOperators,
  inet_dst_route_prefix: inetOperators,
  'inet_src|dst_route_prefix': inetOperators,
  src_bgp_aspath: { ...stringOperators, ...caseSensitiveRegexOperators },
  dst_bgp_aspath: { ...stringOperators, ...caseSensitiveRegexOperators },
  'src|dst_bgp_aspath': { ...stringOperators, ...caseSensitiveRegexOperators },
  src_aspath_noprepend: { ...stringOperators, ...caseSensitiveRegexOperators },
  dst_aspath_noprepend: { ...stringOperators, ...caseSensitiveRegexOperators },
  'src|dst_aspath_noprepend': { ...stringOperators, ...caseSensitiveRegexOperators },
  src_bgp_community: { ...stringOperators, ...caseSensitiveRegexOperators },
  dst_bgp_community: { ...stringOperators, ...caseSensitiveRegexOperators },
  'src|dst_bgp_community': { ...stringOperators, ...caseSensitiveRegexOperators },
  src_bgp_ext_community: { ...stringOperators, ...caseSensitiveRegexOperators },
  dst_bgp_ext_community: { ...stringOperators, ...caseSensitiveRegexOperators },
  'src|dst_bgp_ext_community': { ...stringOperators, ...caseSensitiveRegexOperators },
  src_bgp_large_community: { ...stringOperators, ...caseSensitiveRegexOperators },
  dst_bgp_large_community: { ...stringOperators, ...caseSensitiveRegexOperators },
  'src|dst_bgp_large_community': { ...stringOperators, ...caseSensitiveRegexOperators },
  src_bgp_origin: { ...stringOperators, ...caseSensitiveRegexOperators },
  dst_bgp_origin: { ...stringOperators, ...caseSensitiveRegexOperators },
  'src|dst_bgp_origin': { ...stringOperators, ...caseSensitiveRegexOperators },
  src_route_length: intOperators,
  dst_route_length: intOperators,
  'src|dst_route_length': intOperators,
  application: stringOperators,
  i_input_interface_description: { ...stringOperators, ...regexOperators },
  i_output_interface_description: { ...stringOperators, ...regexOperators },
  'i_input|output_interface_description': { ...stringOperators, ...regexOperators },
  i_ult_exit_interface_description: { ...stringOperators, ...regexOperators },
  i_input_snmp_alias: { ...stringOperators, ...regexOperators },
  i_output_snmp_alias: { ...stringOperators, ...regexOperators },
  'i_input|output_snmp_alias': { ...stringOperators, ...regexOperators },
  i_ult_exit_snmp_alias: { ...stringOperators, ...regexOperators },
  i_input_interface_speed: {
    '>': 'is greater than',
    '<': 'is less than',
    '=': 'equals',
    '<>': 'does not equal'
  },
  i_output_interface_speed: {
    '>': 'is greater than',
    '<': 'is less than',
    '=': 'equals',
    '<>': 'does not equal'
  },
  'i_input|output_interface_speed': {
    '>': 'is greater than',
    '<': 'is less than',
    '=': 'equals',
    '<>': 'does not equal'
  },
  tcp_flags: {
    '&': 'is set',
    bitwiseNone: 'is not set',
    '=': 'is only set',
    '<>': 'does not equal'
  },
  i_device_id: {
    '=': 'equals',
    '<>': 'does not equal',
    ILIKE: 'contains',
    'NOT ILIKE': 'does not contain',
    '~*': 'matches regex',
    '!~*': 'does not match regex',
    misc_flags_set: 'matches Ultimate Exit Device ID',
    misc_flags_not_set: 'does not match Ultimate Exit Device ID'
  },
  i_device_name: {
    '=': 'equals',
    '<>': 'does not equal',
    ILIKE: 'contains',
    'NOT ILIKE': 'does not contain',
    '~*': 'matches regex',
    '!~*': 'does not match regex',
    misc_flags_set: 'matches Ultimate Exit Device Name',
    misc_flags_not_set: 'does not match Ultimate Exit Device Name'
  },
  i_ult_exit_device_name: { ...stringOperators, ...regexOperators },
  i_ult_exit_site: { ...stringOperators, ...regexOperators },
  i_ult_exit_site_country: { ...stringOperators, ...regexOperators },
  i_ult_exit_vrf: stringOperators,
  i_ult_exit_vrf_rd: stringOperators,
  i_site_market: {
    '=': 'equals',
    '<>': 'does not equal',
    ILIKE: 'contains',
    'NOT ILIKE': 'does not contain',
    '~*': 'matches regex',
    '!~*': 'does not match regex',
    misc_flags_set: 'matches Ultimate Exit Site Market',
    misc_flags_not_set: 'does not match Ultimate Exit Site Market'
  },
  i_ult_exit_site_market: { ...stringOperators, ...regexOperators },
  i_inet_ult_exit: inetOperators,
  in_bytes: {
    '>': 'is greater than',
    '<': 'is less than',
    '=': 'equals',
    '<>': 'does not equal'
  },
  out_bytes: {
    '>': 'is greater than',
    '<': 'is less than',
    '=': 'equals',
    '<>': 'does not equal'
  },
  in_pkts: {
    '>': 'is greater than',
    '<': 'is less than',
    '=': 'equals',
    '<>': 'does not equal'
  },
  out_pkts: {
    '>': 'is greater than',
    '<': 'is less than',
    '=': 'equals',
    '<>': 'does not equal'
  },
  both_pkts: {
    '=': 'equals',
    '<>': 'does not equal',
    '<': 'less than',
    '>': '>'
  },
  sampledpktsize: {
    '>': 'is greater than',
    '<': 'is less than',
    '=': 'equals',
    '<>': 'does not equal'
  },
  sampledpktsize_100: {
    '>': 'is greater than',
    '<': 'is less than',
    '=': 'equals',
    '<>': 'does not equal'
  },
  sample_rate: intOperators,
  tcp_retransmit: {
    '>': 'is greater than'
  },
  inet_family: {
    '=': 'equals'
  },
  ipv6_flow_label: intOperators,
  tos: {
    '=': 'equals',
    '<>': 'does not equal',
    '>': 'is greater than',
    '<': 'is less than',
    '&': 'Bitwise AND (&)'
  },
  i_device_site_name: {
    '=': 'equals',
    '<>': 'does not equal',
    ILIKE: 'contains',
    'NOT ILIKE': 'does not contain',
    '~*': 'matches regex',
    '!~*': 'does not match regex',
    misc_flags_set: 'matches Ultimate Exit Site',
    misc_flags_not_set: 'does not match Ultimate Exit Site'
  },
  i_device_site_country: { ...stringOperators, ...regexOperators },
  i_device_label: {
    '=': 'include',
    '<>': 'do not include'
  },
  kflow_dns_query: { ...stringOperators, ...regexOperators },
  kflow_dns_query_type: { ...stringOperators, ...regexOperators },
  kflow_dns_response: { ...stringOperators, ...regexOperators },
  kflow_http_url: { ...stringOperators, ...regexOperators },
  kflow_http_referer: { ...stringOperators, ...regexOperators },
  kflow_http_ua: { ...stringOperators, ...regexOperators },
  kflow_http_host: { ...stringOperators, ...regexOperators },
  i_trf_origination: {
    '=': 'equals',
    '<>': 'does not equal'
  },
  i_trf_termination: {
    '=': 'equals',
    '<>': 'does not equal'
  },
  simple_trf_prof: {
    '=': 'equals',
    '<>': 'does not equal'
  },
  i_trf_profile: {
    '=': 'equals',
    '<>': 'does not equal'
  },
  service_name: { ...stringOperators, ...regexOperators },
  service_type: { ...stringOperators, ...regexOperators },
  service_provider: { ...stringOperators, ...regexOperators },
  ott_classification_type: {
    '>': 'is greater than',
    '<': 'is less than',
    '=': 'equals',
    '<>': 'does not equal'
  },
  repeated_retransmits: intOperators,
  receive_window: intOperators,
  zero_windows: intOperators,
  connection_id: {
    '=': 'equals',
    '<>': 'does not equal'
  },
  client_nw_latency_ms: intOperators,
  server_nw_latency_ms: intOperators,
  appl_latency_ms: intOperators,
  fpex_latency_ms: intOperators,
  i_src_provider_classification: stringOperators,
  i_dst_provider_classification: stringOperators,
  'i_src|dst_provider_classification': stringOperators,
  i_ult_provider_classification: stringOperators,

  /* START AWS Dimensions */
  // src
  kt_aws_src_acc_id: stringOperators,
  kt_aws_src_vm_name: stringOperators,
  kt_aws_src_region: stringOperators,
  kt_aws_src_zone: stringOperators,
  kt_aws_src_zone_id: stringOperators,
  kt_aws_src_vm_type: stringOperators,
  kt_aws_src_image_id: stringOperators,
  kt_aws_src_sg: stringOperators,
  kt_aws_src_asg: stringOperators,
  kt_aws_src_pub_dns: stringOperators,
  kt_aws_src_priv_dns: stringOperators,
  kt_aws_src_vpc_id: stringOperators,
  kt_aws_src_vpc_name: stringOperators,
  kt_aws_src_subnet_id: stringOperators,
  kt_aws_src_subnet_name: stringOperators,
  kt_aws_src_vm_tags: stringOperators,
  // dst
  kt_aws_dst_acc_id: stringOperators,
  kt_aws_dst_vm_name: stringOperators,
  kt_aws_dst_region: stringOperators,
  kt_aws_dst_zone: stringOperators,
  kt_aws_dst_zone_id: stringOperators,
  kt_aws_dst_vm_type: stringOperators,
  kt_aws_dst_image_id: stringOperators,
  kt_aws_dst_sg: stringOperators,
  kt_aws_dst_asg: stringOperators,
  kt_aws_dst_pub_dns: stringOperators,
  kt_aws_dst_priv_dns: stringOperators,
  kt_aws_dst_vpc_id: stringOperators,
  kt_aws_dst_vpc_name: stringOperators,
  kt_aws_dst_subnet_id: stringOperators,
  kt_aws_dst_subnet_name: stringOperators,
  kt_aws_dst_vm_tags: stringOperators,
  // src | dst
  'kt_aws_src|dst_acc_id': stringOperators,
  'kt_aws_src|dst_vm_name': stringOperators,
  'kt_aws_src|dst_region': stringOperators,
  'kt_aws_src|dst_zone': stringOperators,
  'kt_aws_src|dst_zone_id': stringOperators,
  'kt_aws_src|dst_vm_type': stringOperators,
  'kt_aws_src|dst_image_id': stringOperators,
  'kt_aws_src|dst_sg': stringOperators,
  'kt_aws_src|dst_asg': stringOperators,
  'kt_aws_src|dst_pub_dns': stringOperators,
  'kt_aws_src|dst_priv_dns': stringOperators,
  'kt_aws_src|dst_vpc_id': stringOperators,
  'kt_aws_src|dst_vpc_name': stringOperators,
  'kt_aws_src|dst_subnet_id': stringOperators,
  'kt_aws_src|dst_subnet_name': stringOperators,
  'kt_aws_src|dst_vm_tags': stringOperators,
  /* END AWS Dimensions */

  /* START Azure Dimensions */
  // src
  kt_az_src_inst_name: stringOperators,
  kt_az_src_inst_id: stringOperators,
  kt_az_src_region: stringOperators,
  kt_az_src_zone: intOperators,
  kt_az_src_inst_type: stringOperators,
  kt_az_src_fqdn: stringOperators,
  kt_az_src_vnet: stringOperators,
  kt_az_src_subnet: stringOperators,
  kt_az_src_rsrc_group: stringOperators,
  kt_az_src_public_ip: stringOperators,
  kt_az_src_sub_id: stringOperators,
  kt_az_src_sub_name: stringOperators,
  // dst
  kt_az_dst_inst_name: stringOperators,
  kt_az_dst_inst_id: stringOperators,
  kt_az_dst_region: stringOperators,
  kt_az_dst_zone: intOperators,
  kt_az_dst_inst_type: stringOperators,
  kt_az_dst_fqdn: stringOperators,
  kt_az_dst_vnet: stringOperators,
  kt_az_dst_subnet: stringOperators,
  kt_az_dst_rsrc_group: stringOperators,
  kt_az_dst_public_ip: stringOperators,
  kt_az_dst_sub_id: stringOperators,
  kt_az_dst_sub_name: stringOperators,
  // src | dst
  'kt_az_src|dst_inst_name': stringOperators,
  'kt_az_src|dst_inst_id': stringOperators,
  'kt_az_src|dst_region': stringOperators,
  'kt_az_src|dst_zone': intOperators,
  'kt_az_src|dst_inst_type': stringOperators,
  'kt_az_src|dst_fqdn': stringOperators,
  'kt_az_src|dst_vnet': stringOperators,
  'kt_az_src|dst_subnet': stringOperators,
  'kt_az_src|dst_rsrc_group': stringOperators,
  'kt_az_src|dst_public_ip': stringOperators,
  'kt_az_src|dst_sub_id': stringOperators,
  'kt_az_src|dst_sub_name': stringOperators,
  /* END Azure Dimensions */

  /* START K8 Dimensions */
  kt_k8s_src_pod_name: stringOperators,
  kt_k8s_src_pod_ns: stringOperators,
  kt_k8s_src_load_name: stringOperators,
  kt_k8s_src_load_ns: stringOperators,
  kt_k8s_src_svc_name: stringOperators,
  kt_k8s_src_svc_ns: stringOperators,
  kt_k8s_dst_pod_name: stringOperators,
  kt_k8s_dst_pod_ns: stringOperators,
  kt_k8s_dst_load_name: stringOperators,
  kt_k8s_dst_load_ns: stringOperators,
  kt_k8s_dst_cont_name: stringOperators,
  kt_k8s_dst_svc_name: stringOperators,
  kt_k8s_dst_svc_ns: stringOperators,
  'kt_k8s_src|dst_pod_name': stringOperators,
  'kt_k8s_src|dst_pod_ns': stringOperators,
  'kt_k8s_src|dst_load_name': stringOperators,
  'kt_k8s_src|dst_load_ns': stringOperators,
  'kt_k8s_src|dst_svc_name': stringOperators,
  'kt_k8s_src|dst_svc_ns': stringOperators,
  /* END K8 Dimensions */
  ktrac_prefix_len: {
    '=': 'equals',
    '<>': 'does not equal',
    '<<=': 'is contained within'
  },
  kt_src_dns_hostname: stringOperators,
  kt_dst_dns_hostname: stringOperators,
  'kt_src|dst_dns_hostname': stringOperators,
  c_src_dns_hostname: stringOperators,
  c_dst_dns_hostname: stringOperators,
  'c_src|dst_dns_hostname': stringOperators,
  i_src_asn_member_of_ix: {
    '=': 'equals'
  },
  i_dst_asn_member_of_ix: {
    '=': 'equals'
  },
  'i_src|dst_asn_member_of_ix': {
    '=': 'equals'
  },
  i_src_asn_peering_policy: {
    '=': 'equals',
    '<>': 'does not equal'
  },
  i_dst_asn_peering_policy: {
    '=': 'equals',
    '<>': 'does not equal'
  },
  'i_src|dst_asn_peering_policy': {
    '=': 'equals',
    '<>': 'does not equal'
  },
  i_src_asn_available_at_facility: {
    '=': 'equals'
  },
  i_dst_asn_available_at_facility: {
    '=': 'equals'
  },
  'i_src|dst_asn_available_at_facility': {
    '=': 'equals'
  },
  kt_src_pdb_asn_common_ix: {
    pdb_common: 'common with mine',
    pdb_not_common: 'not common with mine'
  },
  kt_dst_pdb_asn_common_ix: {
    pdb_common: 'common with mine',
    pdb_not_common: 'not common with mine'
  },
  'kt_src|dst_pdb_asn_common_ix': {
    pdb_common: 'common with mine',
    pdb_not_common: 'not common with mine'
  },
  kt_src_pdb_asn_common_fac: {
    pdb_common: 'common with mine',
    pdb_not_common: 'not common with mine'
  },
  kt_dst_pdb_asn_common_fac: {
    pdb_common: 'common with mine',
    pdb_not_common: 'not common with mine'
  },
  'kt_src|dst_pdb_asn_common_fac': {
    pdb_common: 'common with mine',
    pdb_not_common: 'not common with mine'
  }
};
